import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { colors } from '../theme/colors';
export function MailIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "20",
      cy: "20",
      r: "20",
      fill: colors.purple
    }), /*#__PURE__*/_jsx("path", {
      d: "M28 12H12C10.9 12 10.01 12.9 10.01 14L10 26C10 27.1 10.9 28 12 28H28C29.1 28 30 27.1 30 26V14C30 12.9 29.1 12 28 12ZM28 26H12V16L20 21L28 16V26ZM20 19L12 14H28L20 19Z",
      fill: "white"
    })]
  });
}